export const devolution = {
	title: "Expired recharges",
	expired: "Expired",
	toExpire: "To expire",
	totalExpired: "Total expired recharges",
	totalToExpire: "Total recharges to expire",
};
